
import { defineComponent, PropType  } from "vue";

export default defineComponent({
  props: {
    go: {
      type: Function as PropType<() => void>,
    },
  },
  methods: {
    onGo: function () {
      if(!this.go) {
        this.goBack();
        return;
      }
      this.go();
    },
    goBack: function () {
      window.history.length > 1 ? this.navigationService.goBack() : this.navigationService.navigate("/");
    },
  },
  computed: {
    visibleBackButton() {
      return window.history.length > 1;
    },
  },
});
